import { ContentfulClient } from 'contentful-shared/src/client'
import type { Entry, EntryCollection } from 'contentful-shared/types'
import { sentryLogging } from 'sentry-utils/logging'

const contentfulSearchConfig = {
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE || 'w65k7w0nsb8q',
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT || 'master',
  accessToken:
    process.env.NEXT_PUBLIC_CONTENTFUL_TOKEN ||
    'b061d6add27f9259b4adfcdde338e0f3fcb18e75eff1b0e4454415a103884a85',
  host: process.env.NEXT_PUBLIC_CONTENTFUL_HOST || 'cdn.contentful.com',
}

const contentfulConfig = {
  ...contentfulSearchConfig,
  removeUnresolved: true,
}

const contentfulClient = new ContentfulClient(contentfulConfig)

const contentfulSearchClient = new ContentfulClient(contentfulSearchConfig)

contentfulClient
  .assertClient(error => {
    sentryLogging({
      team: 'team-frontend-infrastructure',
      severity: 'fatal',
      error: new Error(
        'Invalid configuration for Contentful. Could not get space.'
      ),
      extras: { error },
    })
  })
  .catch(unexpectedError => {
    sentryLogging({
      team: 'team-frontend-infrastructure',
      severity: 'fatal',
      error: new Error(
        'Unexpected error during Contentful client initialization'
      ),
      extras: { error: unexpectedError },
    })
  })

export const getEntriesWrapper = async <T>(
  query?: any
): Promise<EntryCollection<T> | null> => {
  return await contentfulClient.getEntriesWithSys<T>(query)
}

export const getEntryWrapper = async <T>(
  id: string,
  query?: any
): Promise<Entry<T> | null> => {
  return await contentfulClient.getEntryWithSys<T>(id, query)
}

export default contentfulClient
export { contentfulSearchClient }
